export const POLL_QUESTION_TYPE_QUIZ = 0;
export const POLL_QUESTION_TYPE_TEXT = 1;
export const POLL_QUESTION_TYPE_TEXTAREA = 2;
export const POLL_QUESTION_TYPE_TAGS = 3;
export const POLL_QUESTION_TYPE_SWITCH = 4;
export const POLL_QUESTION_TYPE_NUMBER = 5;
export const POLL_QUESTION_TYPE_SELECT = 6;
export const POLL_QUESTION_TYPE_MULTISELECT = 7;
